<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bkht"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>Geschlecht III</h1>
<h1 class="bk1"><span class="sm">SEX,</span> <span class="sm">RACE,</span> <span class="sm">NATION,</span> <span class="sm">HUMANITY</span></h1>
<p class="bkau">Jacques Derrida</p>
<p class="bkau">Edited by Geoffrey Bennington, Katie Chenoweth, and Rodrigo Therezo</p>
<p class="bkau">Translated by Katie Chenoweth and Rodrigo Therezo</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-derrida-geschlecht-0003.vue?5c6aa9ca